import React, {
  Fragment,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { TextArea } from "../../../../../../components/base/Input";
import { useBatch } from "../../../../../../hooks";
import { PhuongAnBoSungsEndpoint } from "../../../../../../service/Meet";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const INI_DATA = [{ noiDung: "", thuTu: 1 }];
const PhuongAns = React.forwardRef(({ vanDeId, data, ...props }, ref) => {
  const [dataPA, setDataPA] = useState(JSON.parse(JSON.stringify(INI_DATA)));
  const [batchData, setBatchData] = useState(null);
  const { updateBatchData } = useBatch();

  const checkBatchData = useCallback(
    (method, data, index) => {
      setBatchData((pre) => updateBatchData(pre, method, data, index));
    },
    [updateBatchData],
  );

  const getDataPA = useCallback(async (id) => {
    const { value } = await PhuongAnBoSungsEndpoint.getDataByIdVanDe(id);
    setDataPA(value);
    setBatchData(value.map((cur) => ({ method: "PATCH", data: cur })));
  }, []);

  useEffect(() => {
    vanDeId && getDataPA(vanDeId);
    data && setDataPA(data);
  }, [vanDeId, getDataPA, data]);

  useImperativeHandle(
    ref,
    () => ({
      getData: () => dataPA,
      getBatchData: () => batchData,
      getDataPA,
    }),
    [batchData, getDataPA, dataPA],
  );

  const onAddItemPhuCap = useCallback(() => {
    setDataPA((pre) => {
      const dataPA = [...pre];
      const newData = {
        thuTu: dataPA.length + 1,
        noiDung: "",
        boSungVanDeId: vanDeId,
      };
      dataPA.push(newData);
      vanDeId && checkBatchData("POST", newData);
      return dataPA;
    });
  }, [checkBatchData, vanDeId]);
  const handleChange = useCallback(
    (key, value) => {
      setDataPA((pre) => {
        const phuongAns = [...pre];
        phuongAns[key].noiDung = value;
        vanDeId && checkBatchData("PATCH", phuongAns[key], key);
        return phuongAns;
      });
    },
    [checkBatchData, vanDeId],
  );
  const onRemove = useCallback(
    (index, dataDelete) => {
      setDataPA((pre) => {
        const dataPA = [...pre];
        if (dataPA.length - 1 !== 0) {
          const i = index || dataPA.length - 1;
          vanDeId && checkBatchData("DELETE", dataPA[i], i);
          dataPA.splice(i, 1);
        }
        return dataPA;
      });
    },
    [checkBatchData, vanDeId],
  );
  return (
    dataPA && (
      <Fragment>
        {/* Toolbar */}
        <div className="pa-toolbar">
          <button
            type="button"
            className="pa-toolbar-btn pa-btn-add"
            onClick={onAddItemPhuCap}
            title="Thêm phương án"
          >
            <AddIcon sx={{ fontSize: 16 }} />
            <span>Thêm</span>
          </button>
          <button
            type="button"
            className="pa-toolbar-btn pa-btn-remove"
            onClick={() => onRemove()}
            title="Xóa phương án cuối"
          >
            <RemoveIcon sx={{ fontSize: 16 }} />
            <span>Xóa</span>
          </button>
          <span className="pa-count">{dataPA.length} phương án</span>
        </div>

        {/* Cards Grid */}
        <div className="pa-cards-grid">
          {dataPA.map((pa, i) => (
            <div className="pa-card" key={"phuongan" + i}>
              <div className="pa-card-badge">{i + 1}</div>
              <div className="pa-card-input">
                <TextArea
                  name="pa"
                  value={pa.noiDung}
                  placeholder={`Nội dung phương án ${i + 1}`}
                  onChange={(e) => handleChange(i, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
      </Fragment>
    )
  );
});
export default PhuongAns;
